module.exports = __webpack_public_path__ + "static/media/Colette Ray Queen Headboard - 155 cm_Black.ea96a58e.png";